// Could be extended in the future

export enum StakeableAvailability {
	ENABLED = "ENABLED",
	SOLD_OUT = "SOLD_OUT",
	DISABLED = "DISABLED"
}
